/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import * as api from '@codegrade/api';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Grader extends api.NormalUser {
    weight;
    done;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromApiServerData(data) {
        return new Grader(data, data.weight, data.done);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(user, weight, done) {
        super(user);
        this.weight = weight;
        this.done = done;
    }
    /** @returns The id of the user, here for backwards comparability reasons. */
    get userId() {
        return this.id;
    }
    /**
     * @returns This instance.
     * @deprecated This getter is useless.
     */
    get user() {
        return this;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    setStatus(value) {
        return new Grader(this, this.weight, value);
    }
}
